enum PlanEditResultConfigTabTypesEnum {
    User,
    Equipment,
    Shift,
    WarehouseVeneer,
    WarehousePlywood,
}

export default PlanEditResultConfigTabTypesEnum;
